import { createContext, ReactNode, useContext, useEffect } from 'react';
import { components } from '@convergence/client';
import { useMeQuery } from '../api/queries/me';
import posthog from 'posthog-js';

export const AuthContext = createContext(
  {} as {
    user?: components['schemas']['MeResponse']['user'];
    isLoading?: boolean;
    error?: Error | null;
  }
);

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = (props: { children: ReactNode }) => {
  const { isLoading, data, error } = useMeQuery();

  useEffect(() => {
    if (data?.user) {
      posthog.identify(data.user.id);
    }
  }, [data?.user]);
  return (
    <AuthContext.Provider value={{ user: data?.user, isLoading, error }}>
      {props.children}
    </AuthContext.Provider>
  );
};
